import Vue from 'vue';
import Vuex from 'vuex';
import User from './user.store';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    appMoreInfo: {},
    message: '',
    ...User.state
  },
  mutations: {
    SOCKET_message: (state, data) => {
      state.message = data;
    },
    ...User.mutations
  },
  actions: {},
  modules: {}
});
